window.UsersTable = (function() {

    var usersTable = false;

    function tableInit(tableClass, route) {

        usersTable = $(tableClass).DataTable({
            dom:"<'row table-filter--pretty'<'col-sm-6'l><'col-sm-6'f>>" +
                "<'row'<'col-sm-12't>>" +
                "<'row table-footer--pretty'<'col-sm-5'i><'col-sm-7'p> r>",
            processing: true,
            language: {
                processing: '',
                search: '',
                searchPlaceholder: "Search",
                lengthMenu: '_MENU_'
            },
            paging: true,
            lengthMenu: [ [10, 25, 50, 100, -1], [10, 25, 50, 100, "All"] ],
            pageLength: 100,
            serverSide: true,
            sAjaxDataProp: "users",
            scrollX: true,
            scrollY: 'calc(100vh - 285px)',
            scrollCollapse: true,
            deferRender: true,
            fnDrawCallback: function() {},
            footerCallback: function(row, data, start, end, display) {
                var api = this.api();
                var data = this.api().ajax.json();
            },
            ajax: {
                url: route,
                data: function(data) {
                    delete data.columns;
                    dataTableAjax.setParams(data);
                }
            },
            columns: [
                {
                    mData: null,
                    sTitle: "Id",
                    render: function(data, type, row) {
                            return xss(data.id);
                    },
                    bSortable: true,
                },
                {
                    mData: null,
                    sTitle: "First Name",
                    render: function(data, type, row) {
                            return xss(data.f_name);
                    },
                    bSortable: true,
                },
                {
                    mData: null,
                    sTitle: "Last Name",
                    render: function(data, type, row) {
                            return xss(data.l_name);
                    },
                    bSortable: true,
                },
                {
                    sTitle: "Email",
                    mData: null,
                    render: function(data, type, full) {
                        return xss(data.email);
                    },
                    bSortable: true
                },
                {
                    sTitle: "User Role",
                    mData: function(source, type, val) {
                        return xss(source.role_name);
                    },
                    bSortable: true
                },
                {
                    sTitle: "Last Login",
                    mData: null,
                    render: function(data, type, full) {
                        return xss(helpers.formatDate(data.last_login, "MM/DD/YYYY, h:mm A"));
                    },
                    bSortable: true
                },
                {
                    sTitle: "Created On",
                    mData: null,
                    render: function(data, type, full) {
                        return xss(helpers.formatDate(data.created_on, "MM/DD/YYYY"));
                    },
                    bSortable: true
                },
                {
                    sTitle: "Last Activated",
                    mData: null,
                    render: function(data, type, full) {
                        return xss(helpers.formatDate(data.latest_activation_date, "MM/DD/YYYY, h:mm A"));
                    },
                    bSortable: true
                },
                {
                    sTitle: "Last De-Activated",
                    mData: null,
                    render: function(data, type, full) {
                        return xss(helpers.formatDate(data.latest_deactivation_date, "MM/DD/YYYY, h:mm A"));
                    },
                    bSortable: true
                },
                {
                    sTitle: "Status",
                    mData: null,
                    render: function(data, type, full) {
                        return (data.status == 1) ? '<span class="label label-success">Active</span>' : '<span class="label label-danger">Inactive</span>';
                    },
                    bSortable: true
                },
                {
                    sTitle: "Is Trial",
                    mData: null,
                    render: function(data, type, full) {
                        return (data.is_trial == 0) ? '<span class="label label-success">Full</span>' : '<span class="label label-danger">Trial</span>';
                    },
                    bSortable: true
                },
                {
                    sTitle: "Actions",
                    mData: null,
                    render: function(data, type, full) {
                        if (data.hide_edit) {
                            return dataTableAjax.renderTemplate(data, '#te-user-actions-dropdown-no-edit');
                        } else {
                            return dataTableAjax.renderTemplate(data, '#te-user-actions-dropdown');
                        }
                    },
                    bSortable: false
                }

            ]
        });
    }

    function init(tableClass, route, callback) {
        $(function() {

            tableInit(tableClass, route);

            var params = usersTable.ajax.params();

            usersTable.on('preXhr', function(e, settings, data) {
                var data = usersTable.ajax.params();
                dataTableAjax.setParams(data);
            });

            //disable search field until intial search is complete
            $('#DataTables_Table_0_filter input').prop('disabled', true)
            usersTable.one('xhr', function(e, settings, json, xhr) {
                return new Promise(function(resolve) {
                    usersTable.search(params.search.value);
                    resolve();
                }).then(() => {
                    $('#DataTables_Table_0_filter input').prop('disabled', false)
                });
                usersTable.page.len(params.length);
            });

            usersTable.on('init', function() {
                if (params.sort) {
                    dataTableAjax.setSortOrder(params.sort);
                } else {
                    dataTableAjax.setSortOrder('f_name');
                }
            });

            if (typeof callback === 'function') {
                callback(usersTable);
            }

        });
    }

    function getTable() {
        return usersTable;
    }

    return {
        init: init,
        usersTable: getTable
    }

})();
